import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function AddTestimonial() {
  const navigate = useNavigate();

  const [testimonial, setTestimonial] = useState({
    name: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BASE_URL}/api/testimonial`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: testimonial.name,
          message: testimonial.message,
        }),
      });
      if (!res.ok) throw new Error("Failed to add testimonial");
      alert("Testimonial added successfully");
      navigate("/admin/testimonialscms");
    } catch (err) {
      setError(err.message || "Failed to add testimonial");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto md:p-6">
      <h1 className="text-2xl font-bold mb-6 text-primaryDark">Add Testimonial</h1>

      <form className="bg-white p-6 rounded-xl shadow space-y-4" onSubmit={handleSubmit}>
          {error && <p className="text-red-500 mb-2">{error}</p>}
        <div>
          <label className="block font-medium mb-1">Client Name</label>
          <input
            type="text"
            className="w-full border px-4 py-2 rounded border-primaryDark/30"
            value={testimonial.name}
            onChange={(e) =>
              setTestimonial({ ...testimonial, name: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Testimonial</label>
          <textarea
            rows="4"
            className="w-full border px-4 py-2 rounded border-primaryDark/30"
            value={testimonial.message}
            onChange={(e) =>
              setTestimonial({ ...testimonial, message: e.target.value })
            }
          />
        </div>

        

        <div className="flex gap-4">
          <button
            type="submit"
            className="bg-primary text-white px-6 py-2 rounded hover:bg-primaryDark"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Testimonial"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/admin/testimonialscms")}
            className="border px-6 py-2 rounded hover:bg-primaryDark hover:text-white"
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
